import React from 'react'

function FunFactsTwo() {
  return (
    <div>
        
        {/* Start Main Counter up-5 Area  */}
        <div className="tmp-counterup-area tmp-section-gapBottom">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-head">
                  <div className="section-sub-title center-title">
                    <img
                      src="assets/images/services/section-custom-menubar.png "
                      alt="Corporate_service"
                    />
                    <span className="subtitle">15000 Trusted</span>
                  </div>
                  <h2 className="title split-collab">Happy customers</h2>
                </div>
              </div>
            </div>
            <div className="row g-5 mt--20 counter_animation">
              <div className="col-lg-3 col-md-6 col-sm-6 col-12 counter__anim wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".1s">
                <div className="count-box counter-style-4 text-center">
                  <div>
                    <h3 className="title">
                      <span className="counter">1538</span>+
                    </h3>
                  </div>
                  <h5 className="counter-title">Happy Clients.</h5>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-6 col-12 counter__anim wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".3s">
                <div className="count-box counter-style-4 text-center">
                  <div>
                    <h3 className="title">
                      <span className="counter">575</span>K+
                    </h3>
                  </div>
                  <h5 className="counter-title">Employees</h5>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-6 col-12 counter__anim wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".5s">
                <div className="count-box counter-style-4 text-center">
                  <div>
                    <h3 className="title">
                      <span className="counter">690</span>+
                    </h3>
                  </div>
                  <h5 className="counter-title">Useful Programs</h5>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-6 col-12 counter__anim wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".7s">
                <div className="count-box counter-style-4 text-center">
                  <div>
                    <h3 className="title">
                      <span className="counter">500</span>M
                    </h3>
                  </div>
                  <h5 className="counter-title">Useful Programs</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Main Counter up-5 Area  */}

    </div>
  )
}

export default FunFactsTwo